import { get } from 'svelte/store';
import * as PROXY from '../../../common/api.js';
import * as PEGASUS from '@smatch/pegasus-api-docs';
import { SUBSCRIPTION_STORE, SUBSCRIPTION_HASH } from './store.js';
import { ORGANIZATION_KEY, USER_KEY } from '../../authentication/services/store.js';
const DOMAIN = import.meta.env.VITE_DOMAIN;
export * from './types.js';
/* eslint-disable arrow-body-style */
// Filter Subscriptions
export const filterSubscriptions = async (parameters = {}) => {
    if (DOMAIN !== 'internal') {
        parameters.organizationKey = get(ORGANIZATION_KEY) ?? '';
        parameters.ownerKey = get(USER_KEY) ?? '';
    }
    return PROXY.handleFilter(PEGASUS.filterSubscriptions, parameters)
        .then(subscriptions => PROXY.updateStoreBulk(SUBSCRIPTION_STORE, subscriptions));
};
// Fetch Subscription
export const fetchSubscription = async (keys, onError) => {
    return PROXY.handleFetch(PEGASUS.fetchSubscription, keys)
        .then(({ data, statusCode }) => {
        if (onError?.(statusCode) === true) {
            return {};
        }
        if (statusCode !== 'STATUS_200') {
            PROXY.handleApiError(statusCode);
            return {};
        }
        return PROXY.updateStore(SUBSCRIPTION_STORE, null, data);
    });
};
// Create Subscription
// eslint-disable-next-line max-len
export const createSubscription = async (body, onError) => {
    return PROXY.handleCreate(PEGASUS.createSubscription, body, { onError, refresh: PROXY.refreshHash.bind(null, SUBSCRIPTION_HASH) }).then(response => {
        if (!response) {
            return null;
        }
        return PROXY.updateStore(SUBSCRIPTION_STORE, SUBSCRIPTION_HASH, response);
    });
};
export const updateSubscription = async (keys, body, onError) => {
    return PROXY.handleUpdate(PEGASUS.updateSubscription, keys, body, { onError, refresh: PROXY.refreshHash.bind(null, SUBSCRIPTION_HASH) }).then(response => {
        if (!response) {
            return null;
        }
        return PROXY.updateStore(SUBSCRIPTION_STORE, SUBSCRIPTION_HASH, response);
    });
};
// Delete Subscription
export const deleteSubscription = async (keys) => {
    return PROXY.handleDelete(PEGASUS.deleteSubscription, keys)
        .then(response => PROXY.removeFromStore(SUBSCRIPTION_STORE, SUBSCRIPTION_HASH, keys.subscriptionKey, response));
};
// Update Subscription State
// eslint-disable-next-line max-len
export const updateSubscriptionState = async (keys, body) => {
    return PROXY.handleUpdate(PEGASUS.updateSubscriptionState, keys, body)
        .then(response => PROXY.updateStore(SUBSCRIPTION_STORE, SUBSCRIPTION_HASH, response));
};
/* eslint-enable arrow-body-style */ 
